import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const tApi = axios.create({ baseURL: `${BASE}/api` });
export const fileUrl = (path) => (path ? `${BASE}${path}` : null);

export const adminHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("sandlab_admin_token")}` });

export const STATUS_CLS = {
  draft: "bg-slate-200 text-slate-700",
  upcoming: "bg-sky-100 text-sky-800",
  open: "bg-emerald-100 text-emerald-800",
  closed: "bg-amber-100 text-amber-800",
  in_progress: "bg-ocean text-white",
  completed: "bg-slate-800 text-white",
};

export const MATCH_STATUS_LABEL = {
  scheduled: "Προγραμματισμένος",
  in_progress: "Σε Εξέλιξη",
  completed: "Ολοκληρώθηκε",
  postponed: "Αναβλήθηκε",
  cancelled: "Ακυρώθηκε",
};

export const REG_STATUS_LABEL = {
  pending: "Εκκρεμεί",
  approved: "Εγκρίθηκε",
  rejected: "Απορρίφθηκε",
  waitlist: "Λίστα αναμονής",
  withdrawn: "Αποχώρησε",
};

export const CATEGORY_LABEL = { women: "Γυναικών", men: "Ανδρών", mixed: "Μικτό", open: "Open" };

export const STAGE_LABEL = { group: "Όμιλοι", semifinal: "Ημιτελικοί", third_place: "Μικρός Τελικός", final: "Τελικός" };

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(`${iso}T00:00:00`);
  return d.toLocaleDateString("el-GR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
};

export const fmtDateShort = (iso) => {
  if (!iso) return "—";
  const d = new Date(`${iso}T00:00:00`);
  return d.toLocaleDateString("el-GR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const setsText = (m) => (m?.sets?.length ? m.sets.map(([a, b]) => `${a}–${b}`).join(", ") : "");

export const errText = (e, fallback = "Κάτι πήγε στραβά") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  return typeof d === "string" ? d : d[0]?.msg || fallback;
};
